import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/Services/api.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { StorageService } from 'src/app/Services/storage.service';


@Component({
  selector: 'g10-information-organization',
  templateUrl: './transport-organization.component.html',
  styleUrls: ['./transport-organization.component.css']
})
export class TransportOrganizationComponent implements OnInit {
  public userInfo: any;
  userType: string;
  public userRestrictionData:any={};
  public showOrgModules:boolean=false;
  constructor(
    public storage: StorageService,
    public api: ApiService,
    public swal: SweetAlert,
  ) 
  {
    
    this.userType = this.storage.get('userType');
    
    this.userInfo = this.storage.get('userInfo');
    const obj = {
      orgID: this.userInfo.orgID
    };
    this.api.org_settingsList(obj).then((res: any) => {
      this.showOrgModules=true;
        let mail=this.userInfo.userEmail;
        let selectedUser=res.data['userInfo'].filter(e=> e.userEmail==mail);
        this.userInfo['fieldMap']=selectedUser[0]['fieldMap'];
        this.storage.setData({ userInfo: this.userInfo });
        let user = this.userInfo;
        if(user && user['fieldMap']){
          this.userRestrictionData=user['fieldMap'];
        }
    }).catch((err) => {
        console.log(err);
    });

  }

  ngOnInit(): void {
    this. getUserData();
  }
  getUserData() {
    this.api.GetCurUserOrg({}).then((res: any) => {
      if (res.status == 'success') {
        this.userInfo = res.data[0];
       
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 2000);
      }
    });
  }
}
